import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IAgentCallsForbiddenTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const AgentCallsForbiddenTagItem = ({ onDeleteClick, withNewTag }: IAgentCallsForbiddenTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Без «Агентам не звонить»
    </TagComponent>
  );
};
